import { HOME_ORGANIZATION_ID } from "./homeProjectImages.js";

// Only the explicitly confirmed owned installations belong in this list.
export const BRAND_INSTALL_PHOTOS = {
  "/brands/viking": [
    {
      baseName: "viking-european-white-oak-birmingham-dining",
      caption: "Dining room with a ¾ inch engineered Viking European white oak floor in Chisholm, Birmingham, MI",
    },
  ],
  "/brands/alterna": [
    {
      baseName: "top-step-flush-mount-vent",
      caption: "TOP Step flush mount vent set into an Armstrong Alterna tile floor",
    },
    {
      baseName: "alterna-hexagon-tile-hardwood-transition",
      caption: "Flush hexagon tile to hardwood transition with no threshold",
    },
    {
      baseName: "alterna-hardwood-tile-fireplace-transition",
      caption: "Armstrong Alterna tile with a mitered dark hardwood border at a fireplace",
    },
  ],
};

export function makeBrandInstallSchemas(path, resolveImage) {
  return (BRAND_INSTALL_PHOTOS[path] || []).flatMap(photo => {
    const url = resolveImage(photo.baseName);
    if (!url || !url.startsWith("https://1woodfloors.com/")) return [];
    return [{
      "@context": "https://schema.org",
      "@type": "ImageObject",
      "@id": `https://1woodfloors.com${path}#photo-${photo.baseName}`,
      contentUrl: url,
      url,
      caption: photo.caption,
      creditText: "1 Wood Floors",
      copyrightHolder: { "@id": HOME_ORGANIZATION_ID },
      creator: { "@id": HOME_ORGANIZATION_ID },
    }];
  });
}